import {createApp} from 'vue';
import {gsap} from "gsap";

function initAddToCart() {
    const divs = document.querySelectorAll('.appAddToCart');
    if (divs.length > 0) {
        divs.forEach((div) => {
            const app = createApp({
                name: "AddToCart - " + div.dataset.unique,
                data() {
                    return {
                        appReady: false,
                        amount: 1,
                        productData: {},
                        roomBooking: false,
                        deskBooking: false,
                        licenseValues: {
                            room_booking: null,
                            desk_booking: null,
                        },
                        dropdownValues: {
                            room_booking: {
                                title: null,
                                sku: null,
                            },
                            desk_booking: {
                                title: null,
                                sku: null,
                            },
                        },
                    }
                },
                computed: {
                    licenses() {
                        return this.productData.hasOwnProperty('licenses');
                    },
                    enableButton() {
                        if(!this.productData.hasOwnProperty('licenses')) return;
                        let anyChecked = this.productData.licenses.filter(license => license.checked).length > 0;
                        return this.licenses && anyChecked;
                    }
                },
                methods: {

                    decrease() {
                        if (this.amount > 1) {
                            this.amount--;
                        }
                    },
                    increase() {
                        this.amount++;
                    },
                    selectLicense() {
                        let app = this;
                        // Update dropdown texts
                        let roomData = this.productData.licenses.find(item => item.slug === 'room_booking');
                        let roomMatch = roomData.options.find(item => item.slug === app.licenseValues.room_booking);
                        if(roomMatch) {

                            console.log(roomMatch);

                            this.dropdownValues.room_booking.title = roomMatch.label;
                            this.dropdownValues.room_booking.sku = roomMatch.sku;
                        }

                        let deskData = this.productData.licenses.find(item => item.slug === 'desk_booking');
                        let deskMatch = deskData.options.find(item => item.slug === app.licenseValues.desk_booking);
                        if(deskMatch){
                            this.dropdownValues.desk_booking.title = deskMatch.label;
                            this.dropdownValues.desk_booking.sku = deskMatch.sku;
                        }
                    },
                    init() {
                        let app = this;

                        // Set initial values
                        if(this.licenses){
                            app.dropdownValues.room_booking.title = this.productData.title;

                            this.productData.licenses.forEach(license => {
                                app.dropdownValues[license.slug].title = license.options[license.options.length-1].label;
                                app.dropdownValues[license.slug].sku = license.options[license.options.length-1].sku;

                                app.licenseValues[license.slug] = license.options[license.options.length-1].slug;
                            });

                            // Check url for paramenters that we can use to set initial values
                            const urlParams = new URLSearchParams(window.location.search);
                            if(urlParams.has('room_booking')){
                                app.productData.licenses.filter(license => license.slug === 'room_booking')[0].checked = true;
                                app.licenseValues.room_booking = urlParams.get('room_booking');
                            }
                            if(urlParams.has('desk_booking')){
                                app.productData.licenses.filter(license => license.slug === 'desk_booking')[0].checked = true;
                                app.licenseValues.desk_booking = urlParams.get('desk_booking');
                            }
                            // If no params present, check all as default
                            if(!urlParams.get('room_booking') && !urlParams.get('desk_booking')) {
                                app.licenseValues.room_booking = 'year_5';
                                app.licenseValues.desk_booking = 'year_5';
                                app.productData.licenses.forEach(license => license.checked = true);

                            }
                            app.selectLicense();



                        }

                        this.appReady = true;

                    },
                    updateProducts() {
                        let app = this;
                        let storage = JSON.parse(localStorage.getItem('webien_cart')) || {};
                        storage.products = storage.products || {};





                        // If licenses, add licenses as products
                        if (this.productData.hasOwnProperty('licenses')) {
                            let activeLicenses = this.productData.licenses.filter(license => license.checked);

                            activeLicenses.forEach(license => {
                                let value = app.licenseValues[license.slug];
                                if(value){
                                    let sku = license.options.find(item => item.slug === value).sku;

                                    /*
                                    // If a license with different value already exists, remove it
                                    for (const key in storage.products) {
                                        if(key.includes(license.slug)){
                                            delete storage.products[key];
                                        }
                                    }

                                     */

                                    // Update local storage with license
                                    if (!storage.products[sku]) {
                                        storage.products[sku] = {
                                            sku: sku,
                                            descr: sku,
                                            title: license.name,
                                            img: license.img,
                                            count: 1,
                                            url: false,
                                            //required: true,
                                            //parent: this.productData.sku,
                                        };
                                    } else {
                                        // One is enough for licenses
                                        //storage.products[sku].count += 1;
                                    }

                                }


                            });
                        }

                        // Normal product
                        else {
                            if (!storage.products[this.productData.sku]) {
                                storage.products[this.productData.sku] = {
                                    sku: this.productData.sku,
                                    descr: this.productData.descr,
                                    title: this.productData.title,
                                    img: this.productData.img,
                                    count: this.amount,
                                    url: window.location.href,
                                    required: false
                                };
                            } else {
                                storage.products[this.productData.sku].count += this.amount;
                            }
                        }


                        localStorage.setItem('webien_cart', JSON.stringify(storage));

                        const appMiniCart = document.getElementById('appMiniCart');
                        if (appMiniCart) {
                            window.appMiniCart.refresh();
                        }

                        // Dispatch event to mini cart
                        let eventUpdated = new Event("cartUpdated", {});
                        window.dispatchEvent(eventUpdated);

                        let eventAdded = new Event("cartAdded", {});
                        window.dispatchEvent(eventAdded);
                    },
                    openElementorPopup(popup_id) {
                        // Popup has been rendered to DOM on page load in index.php
                        window.elementorProFrontend.modules.popup.showPopup({ id: popup_id });
                    },
                },
                mounted() {
                    // Set Plug & Play from localStorage
                    let storage = JSON.parse(localStorage.getItem('webien_cart')) || {};
                    storage.products = storage.products || {};

                    this.productData = JSON.parse(window['product_data_' + div.dataset.unique]);

                    this.init();
                    /*
                    if(storage.products.hasOwnProperty(this.$refs.productInfo.dataset.id)){
                        this.plugPlay = storage.products[this.$refs.productInfo.dataset.id].plugAndPlay;
                    }

                     */
                },
            });

            if (document.getElementById('appAddToCart_' + div.dataset.unique)) {
                window.$appCart = app.mount('#appAddToCart_' + div.dataset.unique);
            }
        });
    }
}

initAddToCart();

jQuery(document).on('jet-filter-content-rendered', initAddToCart);
